import React from "react";
import { MailIcon } from "lucide-react";
import { store } from "../data/contact";
import { BrandLogo } from "./BrandLogo";
export function SiteFooter() {
  return <footer className="bg-cocoa-950 pb-28 text-cream-300 sm:pb-10" data-id="element-259" data-mp="3raluxkkun1sy">
      <div className="mx-auto max-w-6xl border-t border-cream-50/10 px-5 pt-10 text-center" data-id="element-260" data-mp="3mfyem9001dpg">
        <div className="mx-auto max-w-sm" data-id="element-261" data-mp="3hhwv5mynvcdg">
          <BrandLogo className="text-base" data-id="element-262" data-mp="3dguur2t0cu9w" />
          <p className="mt-3 text-sm leading-relaxed text-cream-200" data-id="element-263" data-mp="3dhmftjozb9lx">{store.tagline}</p>
          <a href={`mailto:${store.email}`} className="mt-3 inline-flex items-center gap-2 text-sm text-caramel-300 transition-colors duration-150 hover:text-caramel-400 focus:outline-none focus-visible:text-caramel-400" data-id="element-264" data-mp="38gqb53wszjfg">
            <MailIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-265" data-mp="11rbpw1osnqbm" />
            {store.email}
          </a>
        </div>

        <div className="mt-8 border-t border-cream-50/10 pt-6 text-xs text-cream-300/80" data-id="element-266" data-mp="wrpfs149iq71">
          <p data-id="element-267" data-mp="15r52v0tbher8">
            © {store.year} {store.name}. «De tu cocina a tus primeros pedidos» — Todos los derechos reservados.
          </p>
          <p className="mt-2" data-id="element-268" data-mp="1arja4gn3gko7">Prohibida la reproducción y redistribución sin autorización expresa.</p>
          <p className="mt-2" data-id="element-269" data-mp="vu8oiegqlyer">Producto digital. Los resultados dependen de la aplicación de cada persona.</p>
        </div>
      </div>
    </footer>;
}